// TODO: remove @marvelapp/help dependency when the articles are fully migrated to
// Ballpark
export const HELP = 'https://help.ballparkhq.com/hc/en-us';
export const CONTACT_SUPPORT = `${HELP}/requests/new`;
const ARTICLES = `${HELP}/articles`;
export const TROUBLESHOOTING_FIGMA_ISSUES = `${ARTICLES}/4452646945553-Troubleshooting-Figma-issues-including-loading-times`;
export const ENABLE_SCREEN_SHARING_AND_CAMERA_ACCESS = `${ARTICLES}/6010519393297-How-to-enable-permissions-for-camera-and-screen-sharing`;
export const HOW_TO_STUDY_DESCRIPTION = `${ARTICLES}/8505424265873`;
export const OPTIMISING_PROTOTYPES_FOR_TESTING = `${ARTICLES}/8430019855889-Optimising-your-Figma-and-Marvel-prototypes-for-testing`;
